import ItemReadingPaneViewState from '../store/schema/ItemReadingPaneViewState';
import readingPaneStore from '../store/Store';
import { action } from 'satcheljs/lib/legacy';

export default action('setItemReadingPaneViewState')(function setItemReadingPaneViewState(
    viewState: ItemReadingPaneViewState
) {
    readingPaneStore.itemReadingPaneViewState = viewState;
});
